import { Row, Col, Form, Button } from 'antd';
import React, { ReactElement, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  authFeatureConstants, DRAFT_CHANGE_STATUSES, GUTTOR_SPACE, ROUTE_CHANGE_CONFIRMATION_MESSAGE,
} from '../../../../shared/constants/commonConstants';
import './newAdmission.less';
import PageHeader from '../../../../shared/components/pageHeader/PageHeader';
import { ADMISSION_FORM_TYPES, DEFAULT_ADMISSION_FORM_VALUE, QUERY_DRAFT_FLOW, VALUE_NOT_UPDATED } from '../../../../shared/constants/crmConstants';
import CustomFormStepper from './panels/CustomFormStepper/CustomFormStepper';
import { RootState } from '../../../../store';
import { NewAdmissionState } from '../../../../store/models/newAdmissionModel';
import {
  setSelectedTab,
  setAdmissionForm,
  setSelectedBeneficiary,
  setIsShowAdmissionForm,
  setUploadedFiles,
  setIsMinimize,
  setIsSubmitClicked,
  setBeneficiaryList,
  updatePackageSelection,
  setIsComponentRendered,
  setIsDraftSelected,
  setClassificationArray,
  setbillAmountArray,
  updateDefaultTimeline,
  toggleOtherProcedure,
  toggleFileUploadByForce,
  setAdmissionFormType,
  enableManualSubmission,
  setIsLoadingPreData,
  updateAdmissionStartTime,
  updateSelectedCenter,
  setsubmitDisabled,
  setBeneficiarySearchResponsePayerId,
  setShowPayerUpdatedMessage,
  setIsSuccessModalNewAdmission,
  setIsSubmitClickedFromModal,
  setInsurerID,
} from './../../../../store/actions/newAdmissionAction';
import HeaderRightAction from './panels/HeaderRightActions/HeaderRightActions';
import { clearNewAdmissionState } from '../../../../store/actions/newAdmissionAction';
import SuccessModal from './panels/SuccessModal/SuccessModal';
import { fetchClaimDetails, setClaimData, setClaimMandatoryClassifications } from '../../../../store/actions/claimDetailsAction';
import { base64UrlDecode, canActivate, centeredNotification, emptyFunction, handleResize, isGroupUser } from '../../../../utils/utility';
import { clearPayerLookUp, fetchDiagnosisLookup,
  fetchLookUpValues } from '../../../../store/actions/lookUpAction';
import { Prompt, useHistory } from 'react-router';
import {
  allowGetPatientSearch,
  convertToISOStrings,
  fileUploadCheck, fillFormValuesFromBenef, fillFormValuesFromHIS, findSelectedPayer, getAdmissionFormType, getDetailNav,
  getInsurerDetails,
  getIsPageNameEdit,
  getIsPageNameEditDischarge,
  getIsPageNameNewAdmission, getIsPageNameReconsider, getParsedAttributesObject, getPreviousUrl, mapHISDataToFormFields,
  prefillPayer, reArrangeOptions,
} from '../service/crmUtils';
import DetailTimeline from './panels/cards/DetailTimeline/DetailTimeline';
import { cloneDeep, isEmpty, isEqual } from 'lodash';
import FileUploadMinimize from '../../../../shared/components/fileUpload/FileUploadMinimize';
import BuddhiMedFileUploadModal from '../../../../shared/components/fileUpload/buddhimedFileUploadModal/BuddhiMedFileUploadModal';
import { useMigrateClaimDetail } from '../../../../shared/hooks/useMigrateClaimDetail';
import { PayerInitialState } from '../../../../store/models/payerListModel';
import { Payer } from '../../../../shared/models/payer.model';
import { changePayer, setAllPayers } from '../../../../store/actions/payerListAction';
import { lockUnlockOrDeleteDraft, updateDraftId, updateSaveDraftStatus } from '../../../../store/actions/savedDraftAction';
import { ApplicationDetailModel } from '../../../../store/models/applicationDetailModel';
import ApplicationDetail from '../../../../shared/services/applicationDetail.service';
import { getDefaultTimeline } from '../../../../utils/dateTimeUtils';
import Panel from '../../../../shared/components/card/Panel';
import PayerList from '../../../../shared/components/payerList/PayerList';
import MultipayerFormWrapper from './panels/multipayerFormWrapper/multiPayerFormWrapper';
import useSetDefaultPayer from '../../../../shared/hooks/useSetDefaultPayer';
import moment from 'moment';
import { FormSelect } from '../../../../shared/components/crmFormElement/FormInput';
import { getHospDetail, setUserAuthData } from '../../../../store/actions/authAction';
import {
  fetchHospitalProfile,
  setHISDoctorList, getHISDoctorsList, setIsHISClaim,
  setHISCardSelected,
  getPatientVisitDetails,
  setHospitalPatientSearchDetails,
  setPatientSearchDetail,
  setSuggestedValuesMap,
  setIsHISPackageFilled,
  setParsedHISValuesMap,
} from '../../../../store/actions/hospitalAction';
import { decryptText } from '../../../../utils/encryptDecrypt';
import ConsentModal from './panels/ConsentModal/ConsentModal';
import { FormInstance } from 'antd/lib/form';
import { MailboxType } from '../../../../store/models/mailBoxModel';
import NewAdmissionFooter from './newAdmissionFooter';
import HISSearch from './panels/BeneficiarySearch/HISSearch';
import PolicySearch from './panels/BeneficiarySearch/PolicySearch';
import { clearNHCXState, setPayerDropDownVisible } from '../../../../store/actions/nhcxAction';
import { NHCXState } from '../../../../store/models/nhcxModel';
import BlueBgInformativeAlert from '../../../../shared/components/Alert/BlueBgInformativeAlert';
import { fetchHospitalConfig, fetchPayerConfig, setEnabledPayer } from '../../../../store/actions/mailBoxAction';
import HisSuccessModal from './panels/SuccessModal/HisSuccessModal';
import PageHeaderRedesign from '../../../../shared/components/pageHeader/PageHeaderRedesign';
import LeftHeaderCtaAction from './panels/HeaderRightActions/LeftHeaderCtaAction';
import RightHeaderCtaAction from './panels/HeaderRightActions/RightHeaderCtaAction';
import CONTROL_CONFIG_BASED_ON_PAYER from '../../../../config/formControlConfig';
import HospitalCenterSelect from '../../../../shared/components/hospitalCenterSelect/HospitalCenterSelect';
const NewAdmission = ({ match, location: { pathname } }: any, form: FormInstance): ReactElement | null => {
  const mounted = useRef(false);
  const { payerConfiguration }: MailboxType =
    useSelector((state: RootState): MailboxType => state.mailBox);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [isLookUpLoading, setIsLookUpLoading] = useState(false);
  const [isDetailLoading, setIsDetailLoading] = useState(false);
  const [isFormChanged, setIsFormChanged] = useState(false);
  const [isBackPressed, setIsBackPressed] = useState(false);
  const [originalClaimDetail, setOriginalClaimDetail] = useState({});
  const [hospitalCenterId, setHospitalCenterId] = useState<any>({});
  const [text, setText] = useState<any>([]);
  const buddhimedModalRef = useRef<any>();
  const history = useHistory();
  const isHISSearchEnabled = ApplicationDetail.instance.getIsHISSearchEnabled();
  const isNHCXEnabledProvider = ApplicationDetail.instance.getIsNHCXEnabledProvider();
  const isPreAuthNewDesignEnabled = ApplicationDetail.instance.getIsPreAuthNewDesignEnabled();
  const [admissionForm] = Form.useForm();
  const [buddhimedForm] = Form.useForm();
  const [baseForm] = Form.useForm();
  const { payerDropDownVisible } = useSelector((state: RootState): NHCXState => state.nhcx);
  const dispatch = useDispatch();
  const claimDetailResponse = JSON?.parse(localStorage?.getItem('claimDetailResponse') || '{}');
  useMigrateClaimDetail(isDetailLoading, isLookUpLoading, originalClaimDetail);
  const setDefaultPayer = useSetDefaultPayer();
  const {
    selectedTab,
    admissionFormVal,
    isShowAdmissionForm,
    uploadedFiles,
    isDraftSelected,
    existingClaimError,
    newAdmissionSearchValues,
    admissionFormType,
    resetDetailNav,
    selectedCenter,
    hospitalWisePayerList, isSuccessModalNewAdmission,
    toggleClick, selectedBeneficiaryDetail, updatedMemberName, isArtemis,
  } = useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const { customerDetail, treatmentDetail, billDetail } = admissionFormVal || {};
  const isLoading = isLookUpLoading || isDetailLoading;
  const { params: { claimDetail } } = match;
  const { claimDetails, isArtemisClaim , claimDetails: { patientName } } = useSelector((state: RootState): any =>
    state.admissionDetails);
  const { payer } = useSelector((state: RootState): PayerInitialState => state.payerList);
  const { isBenefSearchEnabled, id, uniqueIdentifier, isOnMailPayer } = payer || {};
  const appDetail = useSelector((state: RootState): ApplicationDetailModel => state.applicationDetail);
  const configuredPayers = useSelector((state: RootState): Payer[] => state.payerList.allPayers);
  const { selectedDraftId } = useSelector((state: RootState): any => state.savedDraft);
  const groupProviders = appDetail.getGroupProviders();
  const appDetailService = ApplicationDetail.instance;
  const isNewAutomationEnabled = appDetailService.getIsNewAutomationEnabled();
  const [detailNav, setDetailNav] = useState(getDetailNav(isNewAutomationEnabled, payer));
  const [centerOptions, setCenterOptions] = useState([]);
  const [hospitalWisePayer, setHospitalWisePayer] = useState([]);
  const [verified, setVerified] = useState(true);
  const [HISOption, setHISOption] = useState();
  const [isCenterSelected, setIsCenterSelected] = useState(false);
  const [is150PercentZoom, setIs150PercentZoom] = useState(false);
  const [onPanelLeave, setPanelLeave] = useState(false);
  const [isHISFields, setIsHISFields] = useState<{ name: string }[]>([]);
  const { nextAllowStatus } = claimDetails || {};
  const { draftValue } = useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const { selectedPatientDetail, hospitalSearchPatientDetails,
    suggestedValuesMap } = useSelector((state: RootState): any => state?.hospital);
  const { selectedPolicyDetail, cardChanged, memberName, radioValue } = useSelector((state: RootState): NHCXState => state?.nhcx);
  const { beneficiarySearchResponsePayerId, showPayerUpdatedMessage, isDateApplied }: any =
    useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const logoutBtnClicked = useSelector(
    ({ hospital: { isLogOutBtnClicked } }: any): any => isLogOutBtnClicked,
  );
  const { payerLookUp }: any = useSelector((state: RootState): RootState => state);
  const isOrionIntegrationEnabledProvider = ApplicationDetail.instance.getIsOrionIntegrationEnabled();

  const isEditPage = getIsPageNameEdit(pathname);
  const isEditDischargePage = getIsPageNameEditDischarge(pathname);
  const isEditReconsider = getIsPageNameReconsider(pathname);
  const editPage = isEditPage || isEditDischargePage || isEditReconsider;
  const { payerConfiguration: payerConfig = {} as any } = useSelector((state: RootState): MailboxType => state?.mailBox || {});
  const { payers } = payerConfig || {};
  const payerFormConfiguration = CONTROL_CONFIG_BASED_ON_PAYER[payer?.name];
  const payerConfigValues = Object.values(payerFormConfiguration || '');
  const loggedInUserId = appDetail?._applicationDetail?.userDetail?.userId;
  const isNewAdmissionPage = getIsPageNameNewAdmission(pathname);

  useEffect((): void => {
    const reArrangeCenterOptions =
      reArrangeOptions(
        groupProviders,
        'providerId',
        'providerName',
        {
          isRestRequired: true,
          additionalLabelKey: 'providerRohiniCode',
          additionalLabelKeyDivider: '|',
        },
      );
    setCenterOptions(reArrangeCenterOptions);
  }, [groupProviders]);

  // PreFill bill details from HIS for all the edit pages
  useEffect((): void => {
    if (editPage) {
      !isEmpty(hospitalSearchPatientDetails?.[0]) && dispatch(setPatientSearchDetail(hospitalSearchPatientDetails[0]));
    }
  }, [hospitalSearchPatientDetails]);

  const data = appDetail?._applicationDetail?.hospitalDetail?.providerConfigurableProperties?.integrationSystemFields;
  const { hisid, hisProviderID } = appDetail?._applicationDetail?.hospitalDetail?.providerConfigurableProperties;

  const { patientDetails } = selectedPatientDetail || {};
  const { payerID, insurerID } = patientDetails || {};
  const ARTEMIS_PAYER = payerConfigValues.filter(({type}: any): boolean => type === 'ARTEMIS').length;

  useEffect((): any => {
    hisfields();
  }, [data]);

  const resetNewAdmissionPage = (): void => {
    initiateMemberForm();
    dispatch(setHospitalPatientSearchDetails([]));
    dispatch(setPatientSearchDetail([]));
    setDefaultPayer();
    baseForm.resetFields();
    dispatch(clearNHCXState());
    setHISOption(undefined);
  };

  useEffect((): void => {
    if (isSuccessModalNewAdmission) {
      resetNewAdmissionPage();
    }
  }, [ isSuccessModalNewAdmission ]);

  useEffect((): any => {
    if (beneficiarySearchResponsePayerId > 0) {
      const finalPayer = configuredPayers.find((p: any): any => (p.id === beneficiarySearchResponsePayerId && p.isGovtScheme === false));
      if (!!finalPayer) {
        dispatch(setShowPayerUpdatedMessage(true));
        setText(['Selected Payer is updated to ', <b key="text1">{finalPayer.name}</b>,
          ' based on the details ', <b key="text2">received from Medi Assist</b>]);
      } else {
        dispatch(setBeneficiaryList([]));
        dispatch(setShowPayerUpdatedMessage(false));
      }
    }
  }, [beneficiarySearchResponsePayerId]);

  const hisfields = (): any => {
    if (data) {
      const HISFieldsKeys = Object?.keys(JSON.parse(data)?.HISFields);
      const finalData = HISFieldsKeys?.map((item: any): any => ({ name: item, value: item }));
      if (!isEqual(finalData, isHISFields)) {
        setIsHISFields(finalData);
      }
    }
  };

  const getAllowedAction = (): any => {
    const blockedAction = payer?.blockedActions || '{}';
    const nextStatus = nextAllowStatus?.length > 0 ? nextAllowStatus[0] : isNewAdmissionPage && 'NEWADMISSION';
    try {
      if ((Object.keys(blockedAction).length) >= 4) {
        centeredNotification(`${payer?.name || 'Selected payer'} has blocked all transactions for ${appDetail.getProviderName()}`);
        return Boolean(blockedAction[nextStatus]);
      } else if (blockedAction[nextStatus]) {
        centeredNotification(`${payer?.name || 'Selected payer'} has blocked Initiating New Admission,
           you can still respond to queries and raise enhancements`);
        return Boolean(blockedAction[nextStatus]);
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  };

  useEffect((): void => {
    if (canActivate(authFeatureConstants.NEW_ADMISSION_BEHALF_OF_HOSPITALS)) {
      setHospitalWisePayer(hospitalWisePayerList);
    }
  }, [hospitalWisePayerList, admissionFormVal]);

  useEffect((): void => {
    if (isEmpty(selectedPatientDetail)) {
      dispatch(setSuggestedValuesMap({}));
      dispatch(setParsedHISValuesMap({}));
      dispatch(setIsHISClaim(false));
      // reseting the admission form during new admission whenever the patient details change;
      if (isNewAdmissionPage) {
        initiateMemberForm();
      }
    }
  }, [selectedPatientDetail]);

  useEffect((): void => {
    if (!isEmpty(selectedPatientDetail)) {
      // computing insurerName based on insurerID match from payerLookUp
      const insurerNameFromHIS = insurerID ? getInsurerDetails(insurerID, payerLookUp[uniqueIdentifier]) : undefined;

      const mappedSuggestedValues = mapHISDataToFormFields(selectedPatientDetail);
      dispatch(setSuggestedValuesMap({
        ...suggestedValuesMap,
        ...mappedSuggestedValues,
        insurerName: insurerNameFromHIS || VALUE_NOT_UPDATED,
      }));
    }
  }, [selectedPatientDetail, payerLookUp[uniqueIdentifier]]);

  useEffect((): void => {
    const selectedPayer = customerDetail?.payerId || customerDetail?.payer;
    if (isDraftSelected) {
      if (canActivate(authFeatureConstants.NEW_ADMISSION_BEHALF_OF_HOSPITALS)) {
        baseForm.setFieldsValue({
          hospitalCenter: customerDetail?.hospitalCenter || appDetailService?.getProviderId(),
        });
        prefillPayer(selectedPayer, configuredPayers, payers, isDraftSelected, dispatch,
          baseForm, true, initiateMemberForm, changePayer, patientDetails, setIsShowAdmissionForm);
      } else {
        baseForm.setFieldsValue({
          payer: selectedPayer,
        });
      }
    } else {
      if (isNHCXEnabledProvider && !isEmpty(selectedPolicyDetail)) {
        baseForm.setFieldsValue({
          payer: selectedPolicyDetail?.payerName,
        });
      }
    }
  }, [admissionFormVal?.customerDetail?.insurerName, isDraftSelected, selectedPolicyDetail]);

  // only used for mapping payers from HIS
  useEffect((): void => {
    if (isNewAdmissionPage && isHISSearchEnabled && !isEmpty(selectedPatientDetail)) {
      if (radioValue === 'mobile' || radioValue === 'abha') {
        dispatch(setPayerDropDownVisible(false));
      } else {
        prefillPayer(payerID, configuredPayers, payers, isDraftSelected, dispatch,
          baseForm, true, initiateMemberForm, changePayer, patientDetails, setIsShowAdmissionForm);
      }
    }
  }, [selectedPatientDetail, radioValue]);

  useEffect((): void => {
    if (isEmpty(selectedPatientDetail) && isEmpty(selectedPolicyDetail)) {
      admissionForm?.setFieldsValue(newAdmissionSearchValues);
    } else {
      if (isNewAdmissionPage && !isDraftSelected) {
        // clearing bill details state
        dispatch(setIsHISPackageFilled(false));
        const parsedHISFieldValues = {
          treatmentAdditionalAttrs: getParsedAttributesObject(selectedPatientDetail?.treatmentDetails?.additionalAttributes || {}),
          patientDetailsAdditionalAttrs: getParsedAttributesObject(selectedPatientDetail?.patientDetails?.additionalAttributes || {}),
          caseDetailsAdditionalAttrs: getParsedAttributesObject(selectedPatientDetail?.caseDetails?.additionalAttributes || {}),
          pastHistoryAdditionalAttrs: getParsedAttributesObject(selectedPatientDetail?.treatmentPastHistory?.additionalAttributes || {}),
        };
        dispatch(setParsedHISValuesMap(parsedHISFieldValues));
        const formValues = fillFormValuesFromHIS(selectedPatientDetail, selectedPolicyDetail, newAdmissionSearchValues, memberName,
            payerLookUp[uniqueIdentifier], parsedHISFieldValues, payerConfigValues, payer);
        admissionForm?.setFieldsValue(formValues);
        // computing insurerName based on insurerID match from payerLookUp
        const insurerNameFromHIS = insurerID ? getInsurerDetails(insurerID, payerLookUp[uniqueIdentifier]) : undefined;

        const insurerName = newAdmissionSearchValues?.insurerName || insurerNameFromHIS;
        admissionForm?.setFieldsValue({ insurerName });
        dispatch(setInsurerID(insurerID));
      }
    }
    // need to check if the getMaxDoctorList is required, if not this can be removed (not used anywhere now since MAX moved to mithril)
    if (isHISSearchEnabled && !isEmpty(selectedPatientDetail)) {
      const lastHSPLocationID = parseInt(selectedPatientDetail?.lastHSPLocationID, 10);
      if (lastHSPLocationID > 0) {
        dispatch(getHISDoctorsList({ hospitalId: lastHSPLocationID }));
      }
    }
  }, [newAdmissionSearchValues, selectedPatientDetail, selectedPolicyDetail, payerLookUp]);

  useEffect((): void => {
    if (!isEmpty(selectedPatientDetail) || !isEmpty(selectedBeneficiaryDetail)) {
      const formValues = fillFormValuesFromBenef(selectedPatientDetail, selectedBeneficiaryDetail, selectedPolicyDetail);
      admissionForm?.setFieldsValue(formValues);
    }
  }, [selectedBeneficiaryDetail]);

  useEffect((): void => {
    if (!isEmpty(claimDetails)) {
      const { allowStatus } = claimDetails;
      const docTypesObj: any = {};
      allowStatus?.map(({ actionName, documentName }: any): any => {
        docTypesObj[actionName] = documentName;
        return docTypesObj;
      });
      dispatch(setClaimMandatoryClassifications(docTypesObj));
    }
  }, [claimDetails]);

  const checkVerified = (): any => {
    const PayerListItem: any = payerConfiguration;
    const payerList = PayerListItem['payers'];
    payerList?.map((payerElement: any): any => {
      if (payerElement['payerID'] === payer?.id) {
        if (payerElement['isEnabled']) {
          setVerified(true);
        } else {
          setVerified(false);
        }
      }
    });
    return verified;
  };

  const successCallback = (claimInfo: any): any => {
    if (mounted.current) {
      setIsDetailLoading(false);
      setOriginalClaimDetail(claimInfo);
    }
    if (isHISSearchEnabled) {
      const allowPatientSearch = allowGetPatientSearch(claimInfo, loggedInUserId, hisid, hisProviderID);
      if (allowPatientSearch?.isAllowed) {
        const updatedHISPayload = allowPatientSearch?.payload;
        // fetch patient details from HIS
        dispatch(getPatientVisitDetails(updatedHISPayload, (): void => { }, (): void => { }));
      }
    }
  };

  const failedCallback = (): any => {
    if (mounted.current) {
      setIsDetailLoading(false);
      dispatch(setClaimData({}));
    }
  };

  const lookUpSuccessCallback = (): void => {
    if (mounted.current) {
      setIsLookUpLoading(false);
      dispatch(setIsLoadingPreData(false));
    }
  };

  const isQueryType = QUERY_DRAFT_FLOW?.some((keyword: any): any => draftValue?.includes(keyword));

  const updateFormType = (selectedPayer: any): any => {
    const formType = getAdmissionFormType(selectedPayer);
    if (formType !== ADMISSION_FORM_TYPES.NORMAL) {
      if (draftValue === 'settlement' || isQueryType) {
        dispatch(toggleFileUploadByForce(false));
      } else {
        dispatch(toggleFileUploadByForce(true));
      }
    }
    dispatch(setAdmissionFormType(formType));
  };

  const initiateMemberForm = (): void => {
    if (beneficiarySearchResponsePayerId === 0) {
      dispatch(setBeneficiaryList([]));
    }
    if (!isDraftSelected) { // changes-to-capture-policy-range-dates-in-draft
      dispatch(setBeneficiaryList([]));
    }
    submitNotifier();
    if ((isNewAdmissionPage || !isEmpty(claimDetails)) && !isDraftSelected) {
      if (!canActivate(authFeatureConstants.NEW_ADMISSION_BEHALF_OF_HOSPITALS)
        && beneficiarySearchResponsePayerId === 0) {
        dispatch(clearNewAdmissionState());
      }
      admissionForm.resetFields();

      dispatch(setIsShowAdmissionForm(false));
      dispatch(toggleOtherProcedure(false));
      dispatch(setAdmissionForm(cloneDeep(DEFAULT_ADMISSION_FORM_VALUE)));
      dispatch(setUploadedFiles([]));
      dispatch(setClassificationArray([]));
      dispatch(setbillAmountArray([]));
      dispatch(setSelectedTab(0));
      dispatch(setClaimData({}));
      dispatch(updatePackageSelection([]));
    }
    dispatch(setBeneficiarySearchResponsePayerId(0));
  };

  useEffect((): any => {
    if (isHISSearchEnabled) {
      if (payer?.id === 0) {
        setIsNew(false);
      } else {
        setIsNew(true);
      }
    }
  }, [payer]);

  useEffect((): void => {
    if (id !== 0) {
      initiateMemberForm();
      if (!isDraftSelected) {
        dispatch(setsubmitDisabled(true));
      }
      updateFormType(payer);
      setDetailNav(getDetailNav(isNewAutomationEnabled, payer));
      if (!isBenefSearchEnabled || isOnMailPayer) {
        (draftValue !== 'settlement' && !isQueryType) && dispatch(enableManualSubmission()); // For settlement flow-multipayer
        dispatch(setIsShowAdmissionForm(true));
        dispatch(setSelectedBeneficiary(null));
      }
      // removed selectedTab condition and clearing diagnosisDynamicLookup whenever the payer changes
      dispatch(fetchDiagnosisLookup([]));
      dispatch(fetchLookUpValues(lookUpSuccessCallback, uniqueIdentifier));
      dispatch(updateAdmissionStartTime(moment().utcOffset('+05:30').format()));
    }
    setVerified(true);
    checkVerified();
  }, [payer, resetDetailNav, selectedCenter, cardChanged]);

  useEffect((): any => {
    if (ARTEMIS_PAYER && isOrionIntegrationEnabledProvider && (isArtemis || isArtemisClaim)) {
    localStorage.removeItem('payerLookUp');
    dispatch(clearPayerLookUp());
    dispatch(fetchLookUpValues(lookUpSuccessCallback, uniqueIdentifier));
  }
}, [isArtemisClaim, isArtemis ]);

  useEffect((): any => {
    if (groupProviders?.length && hospitalCenterId?.['providerId']) {
      dispatch(fetchPayerConfig(hospitalCenterId?.['providerId']));
    }
  }, [hospitalCenterId]);

  useEffect((): any => {
    mounted.current = true;
    return (): boolean => {
      if (window.location.pathname.includes('/new-admission')) {
        return mounted.current = true;
      }
      window.onbeforeunload = emptyFunction;
      window.removeEventListener('popstate', popStateHandler);
      dispatch(setClaimData({}));
      dispatch(clearNewAdmissionState());
      dispatch(setIsSuccessModalNewAdmission(false));
      dispatch(setIsComponentRendered(false));
      dispatch(setIsDraftSelected(false));
      dispatch(lockUnlockOrDeleteDraft({ draftId: selectedDraftId, isLocked: false }));
      dispatch(updateDraftId(0));
      dispatch(updateSaveDraftStatus(DRAFT_CHANGE_STATUSES.NO_CHANGE));
      dispatch(updateDefaultTimeline(getDefaultTimeline()));
      setDefaultPayer();
      if (canActivate(authFeatureConstants.NEW_ADMISSION_BEHALF_OF_HOSPITALS) && logoutBtnClicked === false) {
        const providerDetailString: any = decryptText(localStorage?.getItem('providerDetail') || '{}');
        const providerDetail = JSON?.parse(providerDetailString);
        dispatch(setUserAuthData(providerDetail));
      }
      if (isHISSearchEnabled) {
        dispatch(setHISCardSelected(false));
        dispatch(setHISDoctorList([]));
      }
      if (isNHCXEnabledProvider) {
        dispatch(clearNHCXState());
      }

      return mounted.current = false;
    };
  }, []);

  useEffect((): any => {
    if (isDraftSelected) {
      dispatch(setIsComponentRendered(true));
    } else {
      initiateMemberForm();
      if (claimDetail) {
        const splittedDetail = base64UrlDecode(claimDetail).split('/');
        const providerId = splittedDetail.length > 6 ? splittedDetail[6] : splittedDetail[5];
        const hospId = [];
        hospId?.push(Number(providerId));

        if (canActivate(authFeatureConstants.NEW_ADMISSION_BEHALF_OF_HOSPITALS)) {
          dispatch(getHospDetail(hospId, getHospPayersSuccess, getHospFailure));
        } else {
          getClaimDetails(configuredPayers);
        }
      } else {
        setIsNew(true);
      }
    }
    submitNotifier();
    window.addEventListener('popstate', popStateHandler);
  }, [isDraftSelected]);

  useEffect((): any => {
    handleResize(setIs150PercentZoom);
    window.addEventListener('resize', (): void => handleResize(setIs150PercentZoom));
    return (): any => {
      window.removeEventListener('resize', (): void => handleResize(setIs150PercentZoom));
    };
  }, []);

  const getHospPayersSuccess = (result: any): any => {
    result.rohiniCode = result.providerRohiniCode;
    dispatch(setUserAuthData(result));
    const { configuredPayers: hospWiseConfigurePayers } = result;
    dispatch(setAllPayers(hospWiseConfigurePayers));
    getClaimDetails(hospWiseConfigurePayers);
  };

  const getClaimDetails = (configuredPayersList: any): void => {
    const splittedDetail = base64UrlDecode(claimDetail).split('/');
    const [claimNoEncrypted, actionId, payerId, uniquePayerId, tempProductCode] = splittedDetail;
    const tempClaimNo = base64UrlDecode(claimNoEncrypted);
    const claimNo = (!tempClaimNo || tempClaimNo === 'null' || tempClaimNo === 'undefined') ? undefined : tempClaimNo;
    const productCode = (!tempProductCode || tempProductCode === 'null' || tempProductCode === 'undefined') ? undefined : tempProductCode;

    setIsLookUpLoading(true);
    dispatch(fetchLookUpValues(lookUpSuccessCallback, uniquePayerId));
    dispatch(setIsShowAdmissionForm(true));
    const selectedPayer = findSelectedPayer(configuredPayersList, uniquePayerId);
    if (selectedPayer) {
      dispatch(changePayer(selectedPayer));
      updateFormType(selectedPayer);
      // calling the api when claimdetail data is not there
      if (isEmpty(claimDetails)) {
        dispatch(fetchClaimDetails({
          claimNo,
          actionId: parseInt(actionId, 10),
          payerId: parseInt(payerId, 10),
          productCode,
          successCallback, failedCallback,
        }));
      } else {
        if (!isEmpty(claimDetailResponse)) {
          setIsDetailLoading(false);
          setOriginalClaimDetail(claimDetailResponse);
        } else {
          setIsDetailLoading(false);
          dispatch(setClaimData({}));
        }
      }
      dispatch(updateAdmissionStartTime(moment().utcOffset('+05:30').format()));
    }
  };

  useEffect((): any => {
    if (isFormChanged) {
      window.onbeforeunload = (): string => ROUTE_CHANGE_CONFIRMATION_MESSAGE;
    }
  }, [isFormChanged]);

  const submitNotifier = (): void => {
    setIsFormChanged(false);
    setIsBackPressed(false);
    window.onbeforeunload = emptyFunction;
    detailNav.forEach((element: any): void => {
      element.isTouched = element.isValidated = false;
    });
  };

  const popStateHandler = (ev: PopStateEvent): void => {
    ev.preventDefault();
    setIsBackPressed(true);
  };

  const isFileUploaded = (): boolean => {
    const isUserShouldMoveNext = fileUploadCheck(pathname, uploadedFiles);
    if (!isUserShouldMoveNext) {
      dispatch(setIsMinimize(false));
    }
    return isUserShouldMoveNext;
  };

  const onMemberFormValueChange = ({ fullName }: any): void => {
    if (fullName) {
      const { setFullName = (): void => { } } = buddhimedModalRef.current;
      setFullName(fullName);
    }
    setIsFormChanged(true);
  };

  const onSuccessSubmit = (): void => {
    dispatch(setIsSubmitClicked(false));
    dispatch(setIsSubmitClickedFromModal(false));
    submitNotifier();
    setIsModalVisible(true);
  };

  const taskForAdmissionValBeforeUpdate = (newFormVal: any): any => {
    const { formKey: treatmentDetailKey } = detailNav[1];
    const { formKey: billDetailKey } = detailNav[2];
    if (
      !appDetailService.getIsNewAutomationEnabled() &&
      (newFormVal[treatmentDetailKey]?.roomType !== admissionFormVal[treatmentDetailKey]?.roomType)
    ) {
      dispatch(updatePackageSelection([]));
      newFormVal[billDetailKey] = {
        ...newFormVal[billDetailKey], searchPackage: undefined, Package: undefined,
      };
    }
    const dateRange = admissionForm?.getFieldValue(['stayLength']);
    if (isDateApplied) {
      if (dateRange && Array.isArray(dateRange)) {
        const isoDateRange = convertToISOStrings(dateRange);
        newFormVal[treatmentDetailKey].stayLength = isoDateRange;
      }
    }
    return newFormVal;
  };

  const getAdmissionForm = (): ReactElement => {
    if (payer?.disabled) {
      return (
        <React.Fragment />
      );
    }
    if (!verified) {
      return (
        <React.Fragment />
      );
    }
    if (!payer.isClaimSubmissionDisabled && !getAllowedAction()) {
      if (admissionFormType === ADMISSION_FORM_TYPES.NORMAL && (isNew || isShowAdmissionForm)) {
        return (
          <CustomFormStepper
            commonTabNavigationEnabled={isShowAdmissionForm}
            isLoading={isLoading}
            form={admissionForm}
            buddhimedForm={buddhimedForm}
            detailNav={detailNav}
            formValue={admissionFormVal}
            selectedTab={selectedTab}
            setSelectedTab={(tabIndex: number): any => dispatch(setSelectedTab(tabIndex))}
            setFormValue={setAdmissionForm}
            onValueChange={onMemberFormValueChange}
            tabSwitchExtra={isFileUploaded}
            taskForAdmissionValBeforeUpdate={taskForAdmissionValBeforeUpdate}
            className={isNewAdmissionPage ? 'normal-panel-height' : 'normal-detail-panel-height'}
            isVisible={isNew || isShowAdmissionForm}
            isNewForm={isNew}
          />
        );
      }
      if (payer?.id && admissionFormType === ADMISSION_FORM_TYPES.MULTIPAYER || admissionFormType === ADMISSION_FORM_TYPES.CORPORATE) {
        return (
          <MultipayerFormWrapper
            form={admissionForm}
            buddhimedForm={buddhimedForm}
            className={isNewAdmissionPage ? 'multipayer-panel-height' : 'multipayer-detail-panel-height'}
            isEditPage={editPage}
          />
        );
      }
    }
    return <React.Fragment />;
  };

  const hospitalCenterChangeHandler = (hospitalId: number): void => {
    if (hospitalId) {
      const hospId: number[] = [];
      hospId?.push(hospitalId);
      const selectedCenterFilteredData = (centerOptions || [])?.filter((co: any): any => co?.value === hospitalId);
      const selectedCenterData = selectedCenterFilteredData?.[0] || {};
      setHospitalCenterId(selectedCenterData);
      localStorage?.setItem('datacenter', selectedCenterData?.['name']);
      dispatch(setEnabledPayer(0));
      dispatch(updateSelectedCenter(selectedCenterData));
      setDefaultPayer();
      setIsCenterSelected(true);
      dispatch(getHospDetail(hospId, (result: any): void => getHospSuccess(result, selectedCenterData, hospId), getHospFailure));
    } else {
      setIsCenterSelected(false);
    }
    baseForm.resetFields(['payer']); // clears and resets payer field when center is cleared - group login
    dispatch(clearNewAdmissionState()); // clears the state when center is changed - group login
    setIsFormChanged(false); // state is not getting updated once the field is cleared or reset - group login
  };

  const getHospSuccess = (result: any, selectedCenterData: any, hospId: any): any => {
    result.rohiniCode = result.providerRohiniCode;
    dispatch(setUserAuthData(result));
    dispatch(fetchHospitalProfile({ providerDetails: selectedCenterData }, (): void => { }, getHospFailure));
    const { configuredPayers: hospitalWiseConfiguredPayers } = result;
    const reArrangedPayers =
      reArrangeOptions(
        hospitalWiseConfiguredPayers,
        'uniqueIdentifier',
        'name',
        { isRestRequired: true },
      );
    setHospitalWisePayer(reArrangedPayers);
    dispatch(fetchHospitalConfig(hospId));
    setDetailNav(getDetailNav(appDetailService.getIsNewAutomationEnabled(), payer));
  };

  const getHospFailure = (errMsg: string): any => {
    centeredNotification(errMsg);
    setHospitalCenterId({});
  };

  const changeHospInfoSearch = (event: any): any => {
    setHISOption(event);
  };

  const isNewAdmissionOnBehalf = canActivate(authFeatureConstants.NEW_ADMISSION_BEHALF_OF_HOSPITALS) && isGroupUser();

  const handleMouseLeave = (): any => {
    setPanelLeave(false);
  };

  const handleMouseEnter = (): any => {
    setPanelLeave(true);
  };

  return (
    <><React.Fragment>
      {(isPreAuthNewDesignEnabled && editPage) ?
        <PageHeaderRedesign pageTitle={isNew ? 'New Admission' : isDraftSelected ? updatedMemberName :
          patientName || isNewAdmissionPage ? 'New Admission' : 'Member'}
          backUrl={getPreviousUrl(pathname)} isPreAuthNewDesignEnabled={isPreAuthNewDesignEnabled}
          isNewadmission={isNewAdmissionPage} id={payer?.id} isShowAdmissionForm={isShowAdmissionForm}
          leftComponent={(): ReactElement => (
            <LeftHeaderCtaAction
              form={admissionForm}
              buddhimedForm={buddhimedForm}
              detailNav={detailNav}
              setIsModalVisible={setIsModalVisible}
              submitNotifier={submitNotifier}
              isFormChanged={isFormChanged}
              selectedSearchOption={null} />
          )}
          rightComponent={(): ReactElement => (
            <RightHeaderCtaAction
              form={admissionForm}
              buddhimedForm={buddhimedForm}
              detailNav={detailNav}
              setIsModalVisible={setIsModalVisible}
              submitNotifier={submitNotifier}
              isFormChanged={isFormChanged}
              selectedSearchOption={null} />
          )} /> :
        <PageHeader pageTitle={isNew ? 'New Admission' : isDraftSelected ? updatedMemberName :
          patientName || 'Member'} backUrl={getPreviousUrl(pathname)}
          rightComponent={(): ReactElement => (
            <HeaderRightAction
              form={admissionForm}
              buddhimedForm={buddhimedForm}
              detailNav={detailNav}
              setIsModalVisible={setIsModalVisible}
              submitNotifier={submitNotifier}
              isFormChanged={isFormChanged} />
          )} />}
      <div className={`ant-tabs-content-holder tab-custom-container pb-0 ${(isPreAuthNewDesignEnabled && editPage) ? 'tab-margin-23' : ''}`}
        data-testid="new-admission">
        <Row gutter={GUTTOR_SPACE}>
          <Col md={16}>
            {isNewAdmissionPage &&
              <Form
                form={baseForm}
                requiredMark="optional"
                layout="vertical"
              >

                {process.env.REACT_APP_IS_HIS_SEARCH_ENABLED === 'true' && // env flag added for HIS
                  isHISSearchEnabled && isNewAdmissionPage && !isDraftSelected && // His not to be seen in drafts case

                  <Panel className="payerDropDownPanel">
                    <Row gutter={GUTTOR_SPACE} className="payerSearchDiv">
                      <FormSelect detail={{
                        isLoading,
                        hideLabel: false,
                        form: baseForm,
                        key: 'Fetch Patient Information from HIS',
                        size: 24,
                        options: isHISFields ? isHISFields : [],
                        showSearch: true,
                        allowClear: false,
                        visible: true,
                        placeholder: 'Select HIS Search',
                        onChange: (event: any): any => changeHospInfoSearch(event),
                      }} />

                      </Row>
                    </Panel>}
                  <div className="HIS-search">{HISOption &&
                    <HISSearch selectedOption={HISOption} form={baseForm} resetHISForm={isSuccessModalNewAdmission} />}
                  </div>
                  {process.env.REACT_APP_IS_NHCX_ENABLED === 'true' && isNHCXEnabledProvider && !isDraftSelected &&
                    isNewAdmissionPage && <PolicySearch baseForm={baseForm} />}
                  {payerDropDownVisible &&
                    <Panel className="payerDropDownPanel" onMouseLeave={handleMouseLeave} onMouseEnter={handleMouseEnter}>
                      <Row gutter={GUTTOR_SPACE} className="payerSearchDiv">
                        {isNewAdmissionOnBehalf &&
                          <HospitalCenterSelect
                            isLoading={isLoading}
                            baseForm={baseForm}
                            centerOptions={centerOptions}
                            hospitalCenterChangeHandler={hospitalCenterChangeHandler}
                            onPanelLeave={onPanelLeave}
                            hideLabel={false}
                            size={9}
                            disabled={isDraftSelected}
                          />
                        }
                        <PayerList {...{
                          size: isNewAdmissionOnBehalf ? 15 : 24,
                          form: baseForm,
                          isLoading,
                          hideLabel: false,
                          data: hospitalWisePayer?.length ? hospitalWisePayer : undefined,
                          isCenterSelected,
                          groupProviders,
                          hospitalCenterId,
                          centerId: hospitalCenterId?.['providerId'],
                          onPanelLeave,
                        }} />
                        {payer?.isClaimSubmissionDisabled && <div className="not-configured-error">
                          {payer?.networkActivationMessage}</div>}
                        {payer?.disabled && appDetail.getIsNewMailboxConfigEnabled() &&
                          <Col md={24} className="text-right">
                            <Button type="primary"
                              onClick={(): void => {
                                history.replace('/profile/mailbox');
                              }}>
                              Go To Manage Payers</Button>
                          </Col>}

                      {(payer?.isClaimSubmissionDisabled && payer?.payerReDirectionDtails) &&
                        <Col md={24} className="text-right">
                          <Button type="primary"
                            onClick={(): void => {
                              window.open(
                                JSON.parse(payer?.payerReDirectionDtails || '{}').link,
                                '_blank',
                              );
                            }}>
                            {JSON.parse(payer?.payerReDirectionDtails || '{}')?.lable ||
                              'Redirect to Payer'}
                          </Button>
                        </Col>}
                    </Row>
                  </Panel>}
              </Form>}
            {showPayerUpdatedMessage &&
              <div className="flex flex-element justify-center align-center bg-blue-alert">
                <BlueBgInformativeAlert okButtonRequired={true} onClick={(): any => { dispatch(setShowPayerUpdatedMessage(false)); }}
                  text={text} />
              </div>}
            <Row gutter={GUTTOR_SPACE}>
              <Col md={24}>
                {getAdmissionForm()}
              </Col>
            </Row>
          </Col>
          {payer.id !== 0 &&
            <Col md={8}>
              <FileUploadMinimize />
              <DetailTimeline />
            </Col>}
        </Row>
        {(payer?.id === 0 && !HISOption && (!isNHCXEnabledProvider)) &&
          <Row gutter={GUTTOR_SPACE}>
            <Col md={24} className={is150PercentZoom ? 'footerContent_150zoom' : 'footerContent'}>
              <NewAdmissionFooter />
            </Col>
          </Row>
        }
        {toggleClick && isModalVisible &&
          <ConsentModal />}
        {isModalVisible ?
          isPreAuthNewDesignEnabled ?
            <HisSuccessModal claimDetail={claimDetail}
              isModalVisible={isModalVisible}
              setIsModalVisible={setIsModalVisible}
              form={admissionForm}
              isNew={isNewAdmissionPage} />
            :
            <SuccessModal claimDetail={claimDetail}
              isModalVisible={isModalVisible}
              setIsModalVisible={setIsModalVisible}
              form={admissionForm}
              isNew={isNewAdmissionPage} /> : <></>}
        <Prompt when={((customerDetail || treatmentDetail || billDetail || isBackPressed) && isFormChanged
          && !existingClaimError?.errorMessage)}
          message={'Alert!'} />
      </div>
      <BuddhiMedFileUploadModal
        admissionForm={admissionForm}
        isLoading={isLoading}
        form={buddhimedForm}
        ref={buddhimedModalRef}
        onSuccessSubmit={onSuccessSubmit} />
    </React.Fragment></>
  );
};

export default NewAdmission;
